import type { Book } from "@book-club/shared";
import { useQuery } from "@tanstack/react-query";
import booksService from "@/features/books/services/booksService";
import DURATIONS from "@/shared/constants/durations";
import { booksKeys } from "./booksQueryKeys";

/**
 * Fetches the book scheduled for a given year/month (if any).
 */
export function useBookForMonth(year: number, month: number, options?: { enabled?: boolean }) {
    return useQuery<Book | null, Error>({
        enabled: options?.enabled ?? true,
        gcTime: DURATIONS.ONE_DAY,
        queryFn: () => booksService.getBookForMonth(year, month),
        queryKey: booksKeys.forMonth(year, month),
        staleTime: DURATIONS.FIVE_MINUTES,
    });
}
